import { PackageDefinition, loadSync } from "@grpc/proto-loader"
import grpcConfig from "./config.ts"
import { join } from 'path'

export const loadProto = (path: string): PackageDefinition => {
    return loadSync(join(grpcConfig.path, path), {
        keepCase: true,
        longs: String,
        enums: String,
        defaults: true,
        oneofs: true
    })
}